export const roles = ['admin', 'vendor', 'client'];
